/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiPurewaveSettingQueryResponse, GetApiPurewaveSetting400, GetApiPurewaveSetting401, GetApiPurewaveSetting403, GetApiPurewaveSetting404, GetApiPurewaveSetting500 } from "../../types/GetApiPurewaveSetting.ts";
import { getApiPurewaveSettingQueryResponseSchema } from "../../zod/PureWaveSettingSchemas/getApiPurewaveSettingSchema.ts";

function getGetApiPurewaveSettingUrl() {
  const res = { method: 'GET', url: `/api/purewave-setting` as const }  
  return res
}

/**
 * @summary Получить частоту треков и подкастов
 * {@link /api/purewave-setting}
 */
export async function getApiPurewaveSetting(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiPurewaveSettingQueryResponse, ResponseErrorConfig<GetApiPurewaveSetting400 | GetApiPurewaveSetting401 | GetApiPurewaveSetting403 | GetApiPurewaveSetting404 | GetApiPurewaveSetting500>, unknown>({ method : "GET", url : getGetApiPurewaveSettingUrl().url.toString(), ... requestConfig })  
  return getApiPurewaveSettingQueryResponseSchema.parse(res.data)
}